import { Component, Input, Output, EventEmitter } from '@angular/core';
import { LocationsService } from './../../services/locations';

@Component({
  selector: 'app-gym-services',
  templateUrl: './gym-services.html',
})
export class GymServicesComponent {
  @Input() services: any;
  @Input() serviceListInput: number[];
  @Input() changeable: boolean;
  @Output() selectedServices = new EventEmitter();

  constructor(public locationsService: LocationsService) {}

  serviceList = [false, false, false, false];

  ngOnInit() {
    if (this.services) {
      for (var service of this.services) {
        this.serviceList[service.id - 1] = true;
      }
    }
  }

  ngDoCheck() {
    if (this.serviceListInput) {
      this.serviceList = [false, false, false, false];
      for (var i = 0; i < this.serviceListInput.length; i++) {
        this.serviceList[this.serviceListInput[i] - 1] = true;
      }
      this.emitSelectedServices();
    }
  }

  onSelect(i: number) {
    if (this.changeable) {
      this.serviceList[i] = !this.serviceList[i];
      this.emitSelectedServices();
    }
  }

  emitSelectedServices() {
    var serviceNumberList = [];
    for (let i = 0; i < this.serviceList.length; i++) {
      if (this.serviceList[i]) {
        serviceNumberList.push(i + 1);
      }
    }
    this.selectedServices.emit(serviceNumberList);
  }
}



// WEBPACK FOOTER //
// ./src/components/gym-services/gym-services.ts